import React, { useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";

const colors = {
  textPrimary: '#1e293b',
  textSecondary: '#475569',
  textTertiary: '#94a3b8',
  accent: '#6366f1',
};

export default function Support() {
  useEffect(() => {
    document.title = "Support | KlonIT Web Application";
  }, []);

  const supportChannels = [
    {
      icon: <EmailOutlinedIcon sx={{ fontSize: '1.5rem' }} />,
      label: 'Email Support',
      value: 'support@klonit.net',
      description: 'Response within 24 hours',
      color: '#3b82f6',
    },
    {
      icon: <PhoneOutlinedIcon sx={{ fontSize: '1.5rem' }} />,
      label: 'Phone Support',
      value: '001 123 456 789',
      description: 'Mon-Fri, 9AM-6PM EST',
      color: '#10b981',
    },
    {
      icon: <ChatOutlinedIcon sx={{ fontSize: '1.5rem' }} />,
      label: 'Live Chat',
      value: 'Available 24/7',
      description: 'Instant support via chat',
      color: '#f59e0b',
    },
  ];

  return (
    <Box sx={{ fontFamily, maxWidth: '900px', width: '100%', mx: 'auto' }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Box sx={{
          width: 56,
          height: 56,
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
          boxShadow: '0 8px 24px rgba(99,102,241,0.3)',
        }}>
          <SupportAgentIcon sx={{ color: '#fff', fontSize: 28 }} />
        </Box>
        <Typography sx={{ fontFamily, fontSize: '1.5rem', fontWeight: 700, color: colors.textPrimary, letterSpacing: '-0.02em' }}>
          Support Center
        </Typography>
        <Typography sx={{ fontFamily, fontSize: '0.875rem', color: colors.textTertiary, mt: 0.5 }}>
          We're here to help you succeed
        </Typography>
      </Box>

      {/* Support Channels */}
      <Grid container spacing={3}>
        {supportChannels.map((item, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Box sx={{
              bgcolor: 'rgba(255,255,255,0.8)',
              backdropFilter: 'blur(12px)',
              borderRadius: '16px',
              p: 3,
              border: '1px solid rgba(0,0,0,0.06)',
              textAlign: 'center',
              height: '100%',
            }}>
              <Box sx={{
                width: 48,
                height: 48,
                borderRadius: '12px',
                bgcolor: `${item.color}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
                color: item.color,
              }}>
                {item.icon}
              </Box>
              <Typography sx={{ fontFamily, fontSize: '0.9rem', fontWeight: 600, color: colors.textPrimary, mb: 0.5 }}>
                {item.label}
              </Typography>
              <Typography sx={{ fontFamily, fontSize: '0.95rem', fontWeight: 600, color: item.color, mb: 0.5 }}>
                {item.value}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 1 }}>
                <AccessTimeIcon sx={{ fontSize: '0.85rem', color: colors.textTertiary }} />
                <Typography sx={{ fontFamily, fontSize: '0.75rem', color: colors.textTertiary }}>
                  {item.description}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Additional Info */}
      <Box sx={{
        bgcolor: 'rgba(99,102,241,0.05)',
        borderRadius: '16px',
        p: 3,
        mt: 4,
        border: '1px solid rgba(99,102,241,0.1)',
        textAlign: 'center',
      }}>
        <Typography sx={{ fontFamily, fontSize: '0.9rem', fontWeight: 600, color: colors.textPrimary, mb: 1 }}>
          Priority Support for Enterprise Customers
        </Typography>
        <Typography sx={{ fontFamily, fontSize: '0.85rem', color: colors.textSecondary }}>
          Enterprise plan customers get dedicated support with faster response times and a dedicated account manager.
        </Typography>
      </Box>
    </Box>
  );
}
